import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, OnInit, Output } from '@angular/core';
import { AxsIconComponent } from '@vanguard/axs-angular';
import { ContentService } from 'src/app/shared/services/content/content.service';
import { content } from 'src/assets/content/fallback-content';

@Component({
  selector: 'clear-all-fields-button',
  standalone: true,
  imports: [AxsIconComponent],
  templateUrl: './clear-all-fields-button.component.html',
  styleUrl: './clear-all-fields-button.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ClearAllFieldsButtonComponent implements OnInit {
  @Output() clearAll = new EventEmitter<void>();

  label: string = content.Data.v4_rcc_root.content.calculatorInputs.clearallfields;

  constructor(private readonly contentService: ContentService) {}

  ngOnInit(): void {
    this.contentService.getContent().subscribe((data) => {
      this.label = data.Data.v4_rcc_root.content.calculatorInputs?.clearallfields ?? this.label;
    });
  }
}
